<div class="dialog-menu-comp">
  <div class="search-content-wrap">
    <!-- <nuc-button (click)="closeDialog()" prefixIcon="close" styleClass="dialog-close-button"
      iconColor="#000000"></nuc-button> -->
    <nuc-auto-search id="menu-search-bar" displayClass="input-menu-search"
      placeholder="{{ (data.pageContent | contentFilter : LABELS.MENU_LABELS.SEARCH_MENU) || 'Search Menu' }}"
      [formControl]="searchCtrl" suffix="search" iconColor="#49454F" [options]="searchSubChildItems"
      [filterKeys]="filterKeys" (optionSelected)="onOptionSelected($event)"></nuc-auto-search>
  </div>
  <mat-sidenav-container class="megaMenu-sidenav-container">
    <mat-sidenav mode="side" opened class="megaMenu-sidenav">
      <mat-nav-list class="appLinks-tier1">
        @if(userType !== 'LeapMotor'){
        <mat-list-item class="appLink-list-item" [ngClass]="{ selectedAppLink: selectedTier1Index === 0 }"
          (click)="navigateToSection('frequentlyUsed', 0)">
          <span id="frequently_used">{{ (data.pageContent | contentFilter : LABELS.MENU_LABELS.FREQUENTLY_USED) ||
            "Frequently Used" }}</span>
          <nuc-icon iconClass="arrow_forward"></nuc-icon>
        </mat-list-item>
        }
        <mat-list-item class="appLink-list-item" [ngClass]="{ selectedAppLink: selectedTier1Index === 1 }"
          (click)="navigateToSection('bookmark', 1)">
          <span id="bookmark">{{ (data.pageContent | contentFilter : LABELS.MENU_LABELS.BOOKMARK) || "Bookmark"
            }}</span>
          <nuc-icon iconClass="arrow_forward"></nuc-icon>
        </mat-list-item>
        @for (item of parentMenu; track $index) {
        <mat-list-item class="appLink-list-item" [ngClass]="{ selectedAppLink: selectedTier1Index === $index + 2 }"
          (click)="navigateToSection(item, $index + 2)">
          <span id="tier1_titles">{{ item.label }}</span>
          <nuc-icon iconClass="arrow_forward" *ngIf="item.hasChild"></nuc-icon>
        </mat-list-item>
        }
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="subMenu-wrapper">
        <div class="appLinks-tier2">
          @if(selectedSection === "frequentlyUsed" && userType !== 'LeapMotor'){
          @if(frequentlyVisited?.length > 0){
          <mat-nav-list>
            @for (item of frequentlyVisited; track $index) {
            <mat-list-item class="appLink-list-item" (click)="handleClick(item)">
              <span id="frequently_used">{{ item.label }}</span>
              <nuc-icon *ngIf="item.linkType === 'newTab'" iconClass="stla-externalLink"
                (click)="navigateToLink(item.link, item.linkType, item.category, $event, item.label,item.subCategory)"> </nuc-icon>
            </mat-list-item>
            }
          </mat-nav-list>
          }
          @else {
          <p class="error_text">{{ (data.pageContent| contentFilter : LABELS.MENU_LABELS.FREQUENTLY_USED_MSG) || "No
            FrequentlyUsed
            applinks to show" }}</p>
          }

          } @else { @if(selectedSection === "bookmark" ){
          @if(bookmarked?.length > 0){
          <mat-nav-list>
            @for (item of bookmarked; track $index) {
            <mat-list-item class="appLink-list-item bookmarkItem">
              <nuc-icon class="showBookmarkOnHover" iconClass="close" color="#282B34"
                (click)="removeBookmark(item)"></nuc-icon>
              <div (click)="handleClick(item)" onKeyDown="handleClick(item)" class="appLink-item appLink-bookmark-path">
                <span id="bookmark">{{ item.label }}</span>
                @if(userType === 'LeapMotor'){
                <p class="appLink-path">
                  <span> {{ item.parentMenuLabel }}</span>
               
                 <nuc-icon iconClass="chevron_right" class="lpmi-sm-icon"></nuc-icon>
                <span> {{ item.childMenuLabel }}</span>
                </p>
                }
                <nuc-icon *ngIf="item.linkType === 'newTab'" iconClass="stla-externalLink"
                  (click)="navigateToLink(item.link, item.linkType, item.category, $event, item.label, item.subCategory)"> </nuc-icon>
              </div>
            </mat-list-item>
            }
          </mat-nav-list>
          }
          @else {
          <p class="error_text">{{ (data.pageContent| contentFilter : LABELS.MENU_LABELS.BOOKMARK_MSG) || "No Bookmarks
            to show"
            }}</p>
          }

          } @else{ @for (item of childMenu; track $index) {
          <mat-nav-list>
            <mat-list-item class="appLink-list-item" [ngClass]="{ selectedAppLink: selectedTier2Index === $index }"
              (click)="navigateToSubsection(item, '', $index)">
              <span id="tier2_sub_titles">{{ item.label }}</span>
              <nuc-icon iconClass="arrow_right" *ngIf="item.hasChild"></nuc-icon>
            </mat-list-item>
          </mat-nav-list>
          } } }
        </div>
        @if(selectedSection !== "frequentlyUsed" ){ @if (tier3GroupMenu?.length > 0) {
        <div class="appLinks-tier3-group">
          @for (item of tier3GroupMenu; track $index) {
          <mat-nav-list>
            <mat-list-item class="appLink-list-item" [ngClass]="{ selectedAppLink: selectedTier3Index === $index }"
              (click)="handleTier3Click(item, $index)" (keydown)="handleTier3Click(item, $index)">
              <span id="tier3_group_label">{{ item.label }}</span>
              <nuc-icon iconClass="arrow_right" *ngIf="getActionItems(item).length > 0 && !item.link"></nuc-icon>
            </mat-list-item>
          </mat-nav-list>
          }
        </div>
        } }
        @if(selectedSection !== "frequentlyUsed" ){ @if (subChildMenu) {
        <div class="appLinks-tier3">
          @for (item of subChildMenu; track $index) {
          <mat-nav-list>
            <mat-list-item class="appLink-list-item tier3listItem"
              [ngClass]="{ selectedAppLink: selectedTier3Index === $index }">
              <nuc-icon class="bookmarkIconclass {{ item.iconClass }}" [iconClass]="item.iconClass"
                (click)="updateBookmark(item)" color="#EF7D00"></nuc-icon>
              <div (click)="handleClick(item)" class="appLink-item">
                <span id="tier3_appLins_label">{{ item.label }}</span>
                <nuc-icon *ngIf="item.linkType === 'newTab'" iconClass="stla-externalLink"
                  (click)="navigateToLink(item.link, item.linkType,item.category, $event, item.label, item.subCategory)"> </nuc-icon>
              </div>
            </mat-list-item>
          </mat-nav-list>
          }
        </div>
        } }
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <ng-template #bookmarkDialogTemplate let-data>
    <div mat-dialog-content class="error-message-container">
      <p class="title">Bookmark Limit</p>
      <p class="description">{{ data }}</p>
      <nuc-button text="close" styleClass="bookmark-overlay-close-button"
        (click)="closeBookmarkDialog()"></nuc-button>
    </div>
  </ng-template>
  <div>
    <mat-accordion class="accordion-view-mobile">
      <!-- mobile-view frequently used section -->
      @if(userType !== 'LeapMotor'){
      <mat-expansion-panel class="mobile-applinks-tier1-item">
        <mat-expansion-panel-header class="mobile-tier1-item-header">
          <mat-panel-title>
            <span>{{ (data.pageContent| contentFilter : LABELS.MENU_LABELS.FREQUENTLY_USED) || "Frequently Used"
              }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-accordion class="mobile-applinks-frequentlyUsed">
          @if(selectedSection === "frequentlyUsed" ){
          @if(frequentlyVisited?.length > 0 ){
          <mat-nav-list>
            @for (item of frequentlyVisited; track $index) {
            <mat-list-item class="mobile-applinks-frequentlyUsed-item" (click)="handleClick(item)">
              <span>{{ item.label }}</span>
              <nuc-icon *ngIf="item.linkType === 'newTab'" iconClass="stla-externalLink"
                (click)="navigateToLink(item.link, item.linkType,item.category, $event, item.label, item.subCategory)"> </nuc-icon>
            </mat-list-item>
            }
          </mat-nav-list>
          }
          @else {
          <p class="error_text">{{ (data.pageContent| contentFilter : LABELS.MENU_LABELS.FREQUENTLY_USED_MSG) || "No
            FrequentlyUsed
            applinks to show" }}</p>
          }
          }
        </mat-accordion>
      </mat-expansion-panel>
      }
      <!-- mobile-view bookmark section -->
      <mat-expansion-panel class="mobile-applinks-tier1-item">
        <mat-expansion-panel-header class="mobile-tier1-item-header">
          <mat-panel-title>
            <span>{{ (data.pageContent| contentFilter : LABELS.MENU_LABELS.BOOKMARK) || "Bookmark"
              }}</span></mat-panel-title>
        </mat-expansion-panel-header>
        <mat-accordion class="mobile-applinks-bookmark">
          @if(bookmarked?.length > 0 ){
          <mat-nav-list>
            @for (item of bookmarked; track $index) {
            <mat-list-item class="mobile-applinks-bookmark-item">
              <nuc-icon class="showBookmarkOnHover" iconClass="close" color="#282B34"
                (click)="removeBookmark(item)"></nuc-icon>
              <div
                (click)="handleClick(item)"
                (keydown.enter)="handleClick(item)"
                (keydown.space)="handleClick(item)"
                tabindex="0"
                class="appLink-item appLink-bookmark-path">
                <span>{{ item.label }}</span>
                @if(userType === 'LeapMotor'){
                <p class="appLink-path">
                  <span>{{ item.parentMenuLabel }}</span>
                  <nuc-icon iconClass="chevron_right" class="lpmi-sm-icon"></nuc-icon>
                  <span>{{ item.childMenuLabel }}</span>
                </p>
                }
                <nuc-icon *ngIf="item.linkType === 'newTab'" iconClass="stla-externalLink"
                  (click)="navigateToLink(item.link, item.linkType,item.category, $event, item.label, item.subCategory)"> </nuc-icon>
              </div>
            </mat-list-item>
            }
          </mat-nav-list>
          }
          @else {
          <p class="error_text">{{ (data.pageContent| contentFilter : LABELS.MENU_LABELS.BOOKMARK_MSG) || "No Bookmarks
            to show"
            }}</p>
          }


        </mat-accordion>
      </mat-expansion-panel>
      <!-- Parent Menu -->
      @for (parent of parentMenu; let parentIndex = $index; track $index) {
      <mat-expansion-panel class="mobile-applinks-tier1-item" [expanded]="parentExpanded[parentIndex]" 
      (opened)="onParentPanelToggle(parentIndex)">
        <mat-expansion-panel-header class="mobile-tier1-item-header">
          <mat-panel-title>{{ parent.label }}</mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Child Menu -->
        <mat-accordion class="mobile-applinks-tier2" [multi]="false">
          @for (child of parent.childMenu; let childIndex = $index; track $index) {
          <mat-expansion-panel class="mobile-applinks-tier2-item" [expanded]="childExpanded[parentIndex]?.[childIndex]"
          [hideToggle]="child.category?.toLowerCase() === 'faq'"
          (opened)="onChildPanelToggle(parentIndex, childIndex)">
            <mat-expansion-panel-header class="mobile-tier2-item-header"
              (click)="navigateToMobileSubchild(parent.childMenu, parentIndex, childIndex)">
              <mat-panel-title>{{ child.label }}</mat-panel-title>
            </mat-expansion-panel-header>
            <!-- Subchild Menu -->
            <mat-accordion class="mobile-applinks-tier3">
              @for (subChild of getNormalizedSubChildMenu(child); let subChildIndex = $index; track $index) {
              @if(!subChild.link && getActionItems(subChild).length > 0){
              <mat-nav-list>
                <mat-list-item class="mobile-applinks-tier3-group-item"
                  [ngClass]="{ selectedAppLink: selectedTier3Index === subChildIndex }"
                  (click)="handleTier3Click(subChild, subChildIndex)"
                  (keydown)="handleTier3Click(subChild, subChildIndex)">
                  <div class="mobile-tier3-group-content">
                    <span>{{ subChild.label }}</span>
                    <nuc-icon iconClass="arrow_right"></nuc-icon>
                  </div>
                </mat-list-item>
              </mat-nav-list>
              @if(selectedTier3Index === subChildIndex && subChildMenu?.length > 0){
              @for (menuItem of subChildMenu; track $index) {
              <mat-nav-list>
                <mat-list-item class="mobile-applinks-tier3-item">
                  @if(menuItem.iconClass){
                  <nuc-icon class="bookmarkIconclass {{ menuItem.iconClass }}" [iconClass]="menuItem.iconClass"
                    (click)="updateBookmark(menuItem)" (keydown)="updateBookmark(menuItem)" color="#EF7D00"></nuc-icon>
                  }
                  <div (click)="handleClick(menuItem)" (keydown)="handleClick(menuItem)" class="appLink-item">
                    <span>{{ menuItem.label }}</span>
                    <nuc-icon *ngIf="menuItem.linkType === 'newTab'" iconClass="stla-externalLink"
                      (click)="navigateToLink(menuItem.link, menuItem.linkType, menuItem.category, $event, menuItem.label, menuItem.subCategory)"
                      (keydown)="navigateToLink(menuItem.link, menuItem.linkType, menuItem.category, $event, menuItem.label, menuItem.subCategory)">
                    </nuc-icon>
                  </div>
                </mat-list-item>
              </mat-nav-list>
              }
              }
              }
              @if(subChild.link){
              @for (menuItem of getActionItems(subChild); track $index) {
              <mat-nav-list>
                <mat-list-item class="mobile-applinks-tier3-item">
                  @if(menuItem.iconClass){
                  <nuc-icon class="bookmarkIconclass {{ menuItem.iconClass }}" [iconClass]="menuItem.iconClass"
                    (click)="updateBookmark(menuItem)" (keydown)="updateBookmark(menuItem)" color="#EF7D00"></nuc-icon>
                  }
                  <div (click)="handleClick(menuItem)" (keydown)="handleClick(menuItem)" class="appLink-item">
                    <span>{{ menuItem.label }}</span>
                    <nuc-icon *ngIf="menuItem.linkType === 'newTab'" iconClass="stla-externalLink"
                      (click)="navigateToLink(menuItem.link, menuItem.linkType, menuItem.category, $event, menuItem.label, menuItem.subCategory)"
                      (keydown)="navigateToLink(menuItem.link, menuItem.linkType, menuItem.category, $event, menuItem.label, menuItem.subCategory)">
                    </nuc-icon>
                  </div>
                </mat-list-item>
              </mat-nav-list>
              }
              }
              }
            </mat-accordion>
          </mat-expansion-panel>
          }
        </mat-accordion>
      </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</div>